import styles from "./index.module.css";

import React from "react";
import BaseComponent, {executeComponentCallback} from 'Core/components/BaseComponent';
import PropTypes from "prop-types";
import Label from 'Core/components/display/Label';
import Spinner from 'Core/components/display/Spinner';
import {icon_font_error_symbol, icon_font_stack_class} from 'Config/app';
import Icon from 'Core/components/display/Icon';
import {Tooltip} from 'Core/components/global/Tooltip';
import {
	getScheduleIntervalDescription
} from 'Pages/apps/default/projectPages/campaign/pages/ItemPage/popups/MessageDefinitionPopup/helper';
import {isset} from 'Core/helpers/data';

class DynamicCampaignSchedule extends BaseComponent {
	constructor(props) {
		super(props, {
			translationPath: 'DynamicCampaignSchedule',
			domPrefix: 'campaign-schedule',
			optimizedUpdate: true,
			optimizedUpdateIgnoreProps: ['onClick', 'onReload'],
		});
	}

	
	// Render methods ---------------------------------------------------------------------------------------------------
	render() {
		const {className, disabled, disabledTooltip} = this.props;
		/** @type {DynamicScheduleDataObject} */
		const schedule = this.getProp('schedule');
		const notDefined = !schedule?.intervalType;
		
		return (
			typeof schedule === 'undefined' ?
				<div
					id={this.getDomId()}
					className={`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card`}
					onClick={e => executeComponentCallback(this.props.onReload, e)}
				>
					<Tooltip
						tag="div"
						title={this.t('failedToLoadError')}
						size="small"
						position="top-center"
						arrow={true}
						interactive={false}
					>
						<div className={`card-content ${styles['content']}`}>
							<Icon symbol={icon_font_error_symbol} className="style-error" />
							<Label
								element="p"
								content={this.t(
									'pings_schedule_section',
									'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
								)}
							/>
						</div>
					</Tooltip>
				</div>
			: schedule === null ?
				<div
					id={this.getDomId()}
					className={`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card no-action`}
				>
					<div className={`card-content ${styles['content']}`}>
						<Spinner size={50} />
						<Label
							element="p"
							content={this.t(
								'pings_schedule_section',
								'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
							)}
						/>
					</div>
				</div>
			: !!disabled ?
				<div
					id={this.getDomId()}
					className={`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card no-action`}
				>
					<Tooltip
						tag="div"
						title={disabledTooltip}
						size="small"
						position="top-center"
						arrow={true}
						interactive={false}
					>
						<div className={`card-content ${styles['content']}`}>
							<Icon
								symbol={['calendar-o', 'clock-o']}
								stackClassName={`${icon_font_stack_class} ${notDefined ? 'style-default' : ''} schedule`}
							/>
							<Label
								element="p"
								content={this.t(
									'pings_schedule_section',
									'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
								)}
							/>
							<div className={`description ${styles['description']}`}>
								{notDefined ?
									<Label content={this.t('notSpecified')} />
									:
									<Label
										content={getScheduleIntervalDescription(
											schedule.intervalType, schedule.days, schedule.time, schedule.timeZoneId, true
										)}
										supportHtml={true}
									/>
								}
							</div>
						</div>
					</Tooltip>
				</div>
			:
				<div
					id={this.getDomId()}
					className={
						`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card ` +
						(!isset(this.props.onClick) ? 'no-action' : '')
					}
					onClick={e => executeComponentCallback(this.props.onClick, e)}
				>
					<div className={`card-content ${styles['content']}`}>
						<Icon 
							symbol={['calendar-o', 'clock-o']} 
							stackClassName={`${icon_font_stack_class} ${notDefined ? 'style-default' : ''} schedule`}
						/>
						<Label
							element="p"
							content={this.t(
								'pings_schedule_section',
								'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
							)}
						/>
						<div className={`description ${styles['description']}`}>
							{notDefined ?
								<Label content={this.t('notSpecified')} /> 
								:
								<Label
									content={getScheduleIntervalDescription(
										schedule.intervalType, schedule.days, schedule.time, schedule.timeZoneId, true
									)}
									supportHtml={true}
								/>
							}
						</div>
					</div>
				</div>
		);
	}
}

/**
 * Define the component's own props that can be passed to it by parent components
 */
DynamicCampaignSchedule.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	disabledTooltip: PropTypes.string,
	
	/** @type {DynamicScheduleDataObject} */
	schedule: PropTypes.object,

	onClick: PropTypes.func,
	onReload: PropTypes.func,
};

/**
 * Define component default values for own props
 */
DynamicCampaignSchedule.defaultProps = {
	id: '',
	className: '',
	disabled: false,
	disabledTooltip: '',
};

export default DynamicCampaignSchedule;